import { StepNameCase, StepStatusCase, StepStatusCaseType } from '@/interfaces';

type getIsPhaseProps = {
	steps?: StepStatusCase[];
	stepException?: StepNameCase[];
};

export const getIsPhaseCompleted = ({
	steps,
	stepException,
}: getIsPhaseProps): boolean => {
	if (!steps) return false;

	let isAllPhasesCompleted = false;

	if (stepException) {
		isAllPhasesCompleted = steps
			.filter((elem) => !stepException.includes(elem.name))
			.every((item) => item.status === 'completed');
		return isAllPhasesCompleted;
	}

	isAllPhasesCompleted = steps.every((item) => item.status === 'completed');
	return isAllPhasesCompleted;
};

export const getIsPhaseApproved = ({
	steps,
	stepException,
}: getIsPhaseProps): boolean => {
	if (!steps) return false;

	let isAllPhasesCompleted = false;

	if (stepException) {
		isAllPhasesCompleted = steps
			.filter((elem) => !stepException.includes(elem.name))
			.every((item) => item.status === 'approved');
		return isAllPhasesCompleted;
	}

	isAllPhasesCompleted = steps.every((item) => item.status === 'approved');
	return isAllPhasesCompleted;
};

export const getIsPhaseIncompleted = (steps?: StepStatusCase[]): boolean => {
	if (!steps) return false;
	const isAllPhasesCompleted = steps.some(
		(item) => item.status === 'incomplete'
	);
	return isAllPhasesCompleted || false;
};

export const getStatusPhase = ({
	steps,
	stepException,
}: getIsPhaseProps): StepStatusCaseType => {
	if (getIsPhaseIncompleted(steps)) {
		return 'incomplete';
	} else if (getIsPhaseCompleted({ steps, stepException })) {
		return 'completed';
	} else if (getIsPhaseApproved({ steps, stepException })) {
		return 'approved';
	} else {
		return 'incomplete';
	}
};
export const getStatusStep = (
	stepName: StepNameCase,
	steps?: StepStatusCase[]
): StepStatusCaseType => {
	if (!steps) return 'default';

	const step = steps.find((item) => stepName.includes(item.name));
	return step?.status || 'default';
};

export const getStep = (
	stepName: StepNameCase,
	steps?: StepStatusCase[]
): StepStatusCase | undefined => {
	const step = steps?.find((item) => stepName.includes(item.name));
	return step;
};

export const getIsStepCompleted = (
	stepName: StepNameCase,
	steps?: StepStatusCase[]
): boolean => {
	const step = steps?.find((item) => stepName.includes(item.name))?.status;
	return step === 'completed';
};

export const getIsStepApproved = (
	stepName: StepNameCase,
	steps?: StepStatusCase[]
): boolean => {
	const step = steps?.find((item) => stepName.includes(item.name))?.status;
	return step === 'approved';
};

export const getDateCompletionStep = (): string => {
	return '';
};
